import { useState, useEffect } from "react";

export default function TypesEntretienForm({ onSubmit, entretien }) {
  const [form, setForm] = useState({
    nom: "",
    description	: "",
     
  });

  useEffect(() => {
    if (entretien) setForm(entretien);
  }, [entretien]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <form className="client-form" onSubmit={(e) => {
      e.preventDefault();
      onSubmit(form);
    }}>
      <input name="nom" placeholder="Nom" onChange={handleChange} value={form.nom} />
      <input name="description" placeholder="description" onChange={handleChange} value={form.description	} />
      <button> Enregistrer</button>
    </form>
  );
}
